import XLSX from 'xlsx';

import he from 'he';
import { getPartDescription } from 'redux/reducers';

import $dataRepo from 'dataRepository';

// TODO - switch to ExcelJS if we need cell styles
// https://github.com/guyonroche/exceljs
export default (orderSections, getString, partsStrings) => {
  /* create a new blank workbook */
  const wb = XLSX.utils.book_new();

  /* make worksheet */
  const wsData = orderSections.reduce((acc, orderSection) => ([...acc,
    [getString(orderSection.partsCategory, 'accessories').toUpperCase().replace(/<.+?>/g, '')],
    [getString('description'), getString('part-no'), getString('quantity')],
    ...orderSection.orderList.map(orderItem => ([
      he.decode(getPartDescription(orderItem.part.partNo, partsStrings)),
      orderItem.part.partNo,
      orderItem.quantity.toString()
    ])),
    []
  ]), []);
  const ws = XLSX.utils.aoa_to_sheet(wsData);

  /* cell widths */
  const wsCols = [
    { wch: 100 },
    { wch: 10 },
    { wch: 5 }
  ];
  ws['!cols'] = wsCols;

  /* Add the worksheet to the workbook */
  XLSX.utils.book_append_sheet(wb, ws, 'sheet1');

  return wb;
};

export const download = (wb, filename) => {
  /* output format determined by filename */
  console.log(navigator);
  const iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
  if (!iOS) {
    XLSX.writeFile(wb, `${filename}.xlsx`);
    //console.log(XLSX.utils.sheet_to_html(wb.Sheets.sheet1));
  } else {
    // IF IOS:
    // - Post the worksheet as a blob to hca-connect/sheets (temp file name)
    // - get the url back, and open it in a new window with window.open()
    const wbout = XLSX.write(
      wb,
      {
        bookType: 'xlsx',
        bookSST: false,
        type: 'base64'
      }
    );
    $dataRepo.postWorkbook(wbout);
  }
};
